/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Subject, Observable } from 'rxjs';
import { UndoItem } from './UndoItem';
import { UndoOperationInterface } from './UndoOperationInterface';
import { UndoTypes } from './UndoTypes';

// tslint:disable-next-line: max-line-length
export abstract class BaseUndoOperation<BaseInvalidationCache, BaseUndoItem extends UndoItem>
	implements UndoOperationInterface<BaseInvalidationCache>
{
	protected shutdownSubject$ = new Subject<void>();

	public abstract undoType: UndoTypes;
	public abstract title: string;
	public abstract applyUndo(undoItem: BaseUndoItem): Observable<any>;
	public abstract applyRedo(undoItem: BaseUndoItem): Observable<any>;
	public abstract calculateCombinedInvalidation(list: BaseUndoItem[], existingCache: BaseInvalidationCache);

	/** call this method to push a new undo operation onto the stack */
	protected onPush = (undoItem: BaseUndoItem) => {};
	public registerOnPush(fn: (undoItem: BaseUndoItem) => void) {
		this.onPush = fn;
	}
	/**
	 * call this method to request invalidation cache data and verify the validity
	 * call sequence:
	 * - calls a method on the UndoService which gets cache data
	 * - that method calls the callback function (many) times to check if the cache data is invalid
	 * - that callback either returning null or the list of invalid items
	 */
	protected onVerifyInvalidation = (fn: (cache: BaseInvalidationCache, list: BaseUndoItem[]) => {}) => {};
	public registerVerifyInvalidation(
		fn: (fn: (cache: BaseInvalidationCache, list: BaseUndoItem[]) => BaseUndoItem[]) => void
	) {
		this.onVerifyInvalidation = fn;
	}

	protected onLock = (lock: boolean) => {};
	public registerLock(fn: (lock: boolean) => void) {
		this.onLock = fn;
	}

	public destroy() {
		this.onPush = null;
		this.onVerifyInvalidation = null;
		this.onLock = null;
		this.shutdownSubject$.next();
	}
}
